
<template>
  <div>
    

    <date-picker
      v-model="value"
      format="YYYY-MM-DD"
      display-format="dddd jDD jMMMM jYYYY"
      :element="getElementId"
    >
    </date-picker>

    <input
    v-show="false"
      type="text"
      class="form-control"
      v-model="getShamsi"
      :id="randomId"
      ref="inputDatepicker"
    />

  </div>
</template>

<script>
import DatePicker from "vue-persian-datetime-picker";
import { abstractField } from "vue-form-generator";
import moment from "moment-jalaali";

export default {
  mixins: [abstractField],
  components: {
    datePicker: DatePicker,
  },
  computed: {
    getShamsi() {
      return this.value
        ? moment(this.value, "YYYY-MM-DD").format("dddd jDD jMMMM jYYYY")
        : "";
    },
    randomId() {
      return "inputDatepicker_" + new Date().valueOf();
    },
    getElementId(){
      return  this.$refs.inputDatepicker ? this.$refs.inputDatepicker.id : null
    }
  }
};
</script>